module.exports = __webpack_public_path__ + "media/images/c-pdfBtn/arrow-dfb00dce0cd5c42cf484fcef86261874.svg";